export default __webpack_public_path__ + "static/media/coal.d39e5be0.png";